<template>
  <div class="home">
    <Header :tab="tab" />
    <div class="banner">
      <img :src="topObj.pic" alt="" />
      <div class="banner-box">
        <h5>{{ topObj.title }}</h5>
        <p class="text">
          {{ topObj.desc }}
        </p>
      </div>
    </div>
    <div class="serve">
      <div class="serve-title">
        <div style="color: #194c8b; font-size: 22px">
          {{ dataObj.ser_title }}
        </div>
        <div style="color: #656565; font-size: 12px">
          {{ dataObj.ser_title_english }}
        </div>
      </div>
      <div class="serve-item">
        <div>{{ dataObj.ser_content }}</div>
      </div>
      <div class="serve-box">
        <div class="box" v-for="item in serveList" :key="item.id">
          <img :src="item.pic" alt="" />
          <div style="font-size: 12px">{{ item.title }}</div>
        </div>
        <!-- <div class="box">
          <img src="../assets/image/phone.png" alt="" />
          <div style="font-size: 12px">推广服务</div>
        </div>
        <div class="box">
          <img src="../assets/image/phone.png" alt="" />
          <div style="font-size: 12px">推广服务</div>
        </div>
        <div class="box">
          <img src="../assets/image/phone.png" alt="" />
          <div style="font-size: 12px">推广服务</div>
        </div> -->
      </div>
    </div>
    <div style="height: 22px"></div>
    <div class="intro">
      <div class="intro-img">
        <img :src="dataObj.enter_pic" alt="" />
      </div>
      <div class="intro-text">
        <div class="intro-text-box">
          <div class="intro-text-box-title">{{ dataObj.enter_title }}</div>
          <div
            style="
              width: 70px;
              border-bottom: 1px #09295c solid;
              margin-bottom: 40px;
            "
          ></div>
          <div class="intro-text-box-content">
            <p>
              {{ dataObj.enter_content }}
            </p>
            <!-- <p>
              我们的企业坐落于佛山市南海区桂城街道南平西路13号承业大厦第十一层09单元之一，地理位置优越，交通便利,
              为公司的业务发展提供了良好的环境。
            </p>
            <p>
              亿鹏科技致力于为客户提供多元化的服务，包括技术服务、技术开发、技术咨询、技术交流、技术转让及技术推厂等。
            </p>
            <p>
              此外，我们还提供汽车拖车、求援、清障服务，代驾服务以及洗车服务，以满足客户在日常生活中的各种需求在软件开发与信息技术咨询服务方面，我们拥有专业的技术团队和丰富的经验，能够为客户提供高效、安全的解决方案。
            </p>
            <p>
              同时，我们还涉及数字文化创意内容应用服务，通过创新的方式为客户提供别具一格的创意内容。
            </p> -->
          </div>
        </div>
        <div class="intro-text-box">
          <div class="intro-text-box-title">{{ dataObj.corps_titles }}:</div>
          <!-- <div style="width: 30px; border-bottom: 1px #000 solid"></div> -->
          <div class="intro-text-box-content">
            {{ dataObj.corps_contents }}
          </div>
        </div>
      </div>
    </div>
    <Footer :footerObj="footerObj" />
  </div>
</template>

<script>
import Header from "@/components/header/index.vue";
import Footer from "@/components/footer/index.vue";
import { getIndex } from "@/api/index.js";
// @ is an alias to /src

export default {
  name: "HomeView",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      tab: 1,
      topObj:{},
      dataObj: {},
      serveList: [],
      footerObj: {},
    };
  },
  mounted() {
    document.title = "广州市同航智能技术有限公司官方网站";
    this.getIndex();
  },
  methods: {
    getIndex() {
      getIndex().then((res) => {
        this.topObj=res.top
        this.dataObj = res.data;
        this.serveList = res.imgs;
        this.footerObj = res.rq;
        console.log("res", res);
      });
    },
    handleTo() {
      console.log("2");
      this.$router.push("https://beian.miit.gov.cn");
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  // padding: 0;
  .banner {
    height: 400px;
    width: 100%;
    position: relative;
    color: #fff;

    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      vertical-align: top;
      transition: all 0.6s;
      cursor: pointer;
      object-fit: cover;
      &:hover {
        transform: scale(1.2);
      }
    }
    .banner-box {
      padding: 20px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
      background-color: rgba(30, 104, 167, 0.5);
      // opacity: 0.6;
      width: 400px;
      height: 150px;
      .text {
        font-size: 12px;
      }
    }
  }
  .serve {
    height: 500px;
    width: 100%;
    background: no-repeat;
    background-image: linear-gradient(
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0.5)
      ),
      url("../assets/image/banner2.jpg");
    background-size: cover;
    .serve-title {
      text-align: center;
      padding: 30px 0;
    }
    .serve-item {
      text-align: center;
      color: #000;
    }
    .serve-box {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .box {
        margin-top: 80px;
        width: 200px;
        height: 200px;
        background-color: #fff;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 100px;
          height: 100px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .intro {
    height: 600px;
    width: 100%;
    background-color: #f3f7ff;
    display: flex;
    .intro-img {
      // margin-top: 45px;
      // margin-left: 150px;
      // padding: 50px;
      margin-top: 50px;
      margin-left: 50px;
      width: 50%;
      height: 500px;
      overflow: hidden;
      img {
        width: 100%;
        height: 500px;
        transition: all 0.6s;
        cursor: pointer;
        object-fit: cover;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
    .intro-text {
      padding: 50px;
      // margin-left:200px;
      text-align: left;
      // width: 600px;
      width: 50%;
      .intro-text-box {
        margin-bottom: 30px;
        .intro-text-box-title {
          color: #0a2a5d;
          font-size: 24px;
          margin-bottom: 20px;
        }
        .intro-text-box-content {
          color: #bdc4d6;
          font-size: 12px;
        }
      }
    }
  }

  // img {
  //   width: 100%;
  //   height: 100%;
  //   vertical-align: top;
  //   // padding: 0;
  //   // display: block;
  // }
}
</style>
